import type { BaseQueryApi } from '@reduxjs/toolkit/query';
import { jwtDecode } from 'jwt-decode';

import type { RootState } from '@app/store/store';

export const prepareOirRequestHeaders = (headers: Headers, api: Pick<BaseQueryApi, 'getState'>): Headers => {
  const state = api.getState() as RootState;
  const token = state.authentication?.token;

  if (token) {
    headers.set('authorization', `Bearer ${token}`);
  }

  return headers;
};

export const getEmailFromAccessToken = (token: string): string => {
  if (!token) {
    throw new Error('Access token is missing or empty');
  }

  let decoded: { sub?: string };

  try {
    decoded = jwtDecode<{ sub?: string }>(token);
  } catch (error) {
    throw new Error(`Failed to decode access token: ${(error as Error).message}`, {
      cause: error,
    });
  }

  if (!decoded.sub) {
    throw new Error('Access token is missing the "sub" (email) claim');
  }

  return decoded.sub;
};

export const getAccessTokenExpiryMs = (token: string): number | null => {
  if (!token) {
    return null;
  }

  try {
    const { exp } = jwtDecode<{ exp?: number }>(token);
    return typeof exp === 'number' ? exp * 1000 : null;
  } catch {
    return null;
  }
};
